import { useEffect, useState } from 'react';
import { getLocale, subscribe, t, type Locale } from '../i18n';

type Props = {
    state: 'connected' | 'connecting' | 'disconnected' | 'reconnected' | 'error';
};

export default function ConnectionBanner({ state }: Readonly<Props>) {
    useLocaleRerender(); // re-render on locale changes
    const text = getConnectionStatusString(state);
    if (text === null) return null;
    return (
        <div className="mb-3 rounded-xl border border-amber-200 bg-amber-50 text-amber-900 px-3 py-2 text-sm">
            {text}
        </div>
    );
}

function getConnectionStatusString(state: string): string | null {
    switch (state) {
        case 'connected':
            return null;
        case 'connecting':
            return t('banner.connecting');
        case 'disconnected':
            return t('banner.disconnected');
        case 'reconnected':
            return t('banner.reconnected');
        default:
            return t('banner.error');
    }
}

function useLocaleRerender() {
    const [, setLocale] = useState<Locale>(getLocale());
    useEffect(() => subscribe(setLocale), []);
}
